import moment from 'moment'
import 'moment/locale/en-gb'

import 'script-loader!./vendor/history.js'
import 'script-loader!./vendor/history.adapter.jquery.js'

import './profiler/plugin-registry'
import './profiler/app.jquery'
import './profiler/app-public.jquery'
import './profiler/sidebarnavigation.jquery'
import './profiler/contentheader.jquery'
import './profiler/legacy.js'

moment.locale('en-gb')
